<div id="slider-filter-backdrop" class="slider-filter-backdrop" [ngClass]="{'slider-filter-backdrop-open': isOpen}"></div>
<div id="slider-filter-overlay" [ngClass]="{'overlay': isOpen}" (click)="startFilter(valuesSentForFilters.entity)"></div>
<div id="slider-filter-content" class="slider-filter-content" [ngClass]="{'slider-open': isOpen}">
  <div id="slider-filter-header" #stickyFilterHeader class="slider-filter-header" >
    <div id="slider-filter-label" class="label">
      Filter {{ valuesSentForFilters.displayLabel || (valuesSentForFilters.entity | titlecase) }}
    </div>
    <div id="slider-filter-close-btn" class="close-button" (click)="startFilter(valuesSentForFilters.entity)">
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M18 6L6 18M6 6l12 12" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>
  <div id="slider-filter-body" class="slider-filter-body">
    <ng-content></ng-content>
  </div>
  <div id="slider-filter-footer" class="slider-filter-footer">
    <div class="slider-filter-footer-items">
      <button id="slider-filter-reset-btn" class="btn btn-default" (click)="resetFilter(valuesSentForFilters.entity)">Reset</button>
    </div>
    <div class="slider-filter-footer-items">
      <button id="slider-filter-apply-btn" class="btn  btn-primary" (click)="startFilter(valuesSentForFilters.entity)">Filter</button>
    </div>
  </div>
</div>
